import React from 'react'
import Navigation from "./Navbar";
import Footer from "./Footer";

const Association = () => {
  return (
     <div>

   <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
    <Navigation/>
   </div>
     <div className='pt-[200px] text-center text-xl font-bold'><h1>Coming Soon.....</h1></div>
        <main
        className="relative z-10 pt-[150px]"  
        
      >
        <Footer />
      </main>
     </div>
  )
}

export default Association